import { render } from "./i-terminal.vue?vue&type=template&id=7795e30c"
import script from "./i-terminal.vue?vue&type=script&lang=js"
export * from "./i-terminal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__